/* tslint:disable */
import 'core-js/es6';
import 'core-js/es7/reflect';
import 'intersection-observer';
import 'zone.js/dist/zone';

declare var process: any;
declare var require: any;

if (process.env.ENV === 'production') {
    // Production
} else {
    // Development
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/polyfills.ts